import type { ReactNode } from "react";

import type { CustomerDTO } from "@ifa/utils";

import type { CustomerNavKey, CustomerDetailSectionMode } from "../../zuuMode.js";
import styles from "./ZuuCustomerDetail.module.css";

type ZuuCustomerDetailProps = {
  customer: CustomerDTO | null;
  activeNav: CustomerNavKey;
  onNavigate: (nav: CustomerNavKey) => void;
  renderDashboard: () => ReactNode;
  renderSharedSection: (mode: Exclude<CustomerDetailSectionMode, "original" | "zuu-dashboard">) => ReactNode;
  resolveSectionMode: (nav: CustomerNavKey) => CustomerDetailSectionMode;
};

const navItems: Array<{ key: CustomerNavKey; label: string; badgeKey?: keyof CustomerDTO }> = [
  { key: "fna", label: "ZUU 資料總覽", badgeKey: "fnaCount" },
  { key: "profile", label: "客戶資料", badgeKey: "policyholderCount" },
  { key: "insured", label: "受保人", badgeKey: "insuredCount" },
  { key: "beneficiary", label: "受益人", badgeKey: "beneficiaryCount" },
  { key: "history", label: "歷史訂單", badgeKey: "orderCount" },
];

export function ZuuCustomerDetail({
  customer,
  activeNav,
  onNavigate,
  renderDashboard,
  renderSharedSection,
  resolveSectionMode,
}: ZuuCustomerDetailProps) {
  const sectionMode = resolveSectionMode(activeNav);

  return (
    <div className={styles.body}>
      <div className={styles.sideNav}>
        {navItems.map((item) => {
          const badgeValue = Number(customer?.[item.badgeKey ?? "fnaCount"] ?? 0);
          return (
            <div
              key={item.key}
              className={`${styles.navItem} ${activeNav === item.key ? styles.navItemActive : ""}`}
              onClick={() => onNavigate(item.key)}
            >
              <span>{item.label}</span>
              <span className={styles.badge}>{badgeValue}</span>
            </div>
          );
        })}
      </div>

      <div className={styles.content}>
        {sectionMode === "zuu-dashboard"
          ? renderDashboard()
          : renderSharedSection(sectionMode as Exclude<CustomerDetailSectionMode, "original" | "zuu-dashboard">)}
      </div>
    </div>
  );
}
